import { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import RouteApi from "../Backend/Backend";
import { isMobile } from "react-device-detect";


const CBTCarousel = ({ cbtList, loadCbtList }) => {

  const { deleteCbtByToken } = RouteApi(); // ensure it's exported from Backend.js

  const navigate = useNavigate();
  const swiperRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay
    if (cbtList && cbtList.length > 0) {
      setTimeout(() => {
        setLoading(false);
      }, 1200); // 1.2s fake delay
    }
  }, [cbtList]);

  const handleDeleteCbt = async (tokenId) => {
    if (!window.confirm("Are you sure you want to delete this CBT?")) return;

    const res = await deleteCbtByToken(tokenId);

    if (res.success) {
      toast.success("✅ CBT deleted successfully");
      loadCbtList(); // refresh after delete
    } else {
      toast.error("❌ Failed to delete CBT");
    }
  };

  return (
    <div className="mt-8 col-12 position-relative">
      <div className="text-gray fs-t fw-semibold mb-4">All CBTs</div>

      <div className="position-relative px-4 px-lg-0">
        {/* Floating Arrows */}
        <button
          className="btn btn-purple3 rounded-circle btn-icon position-absolute mt-7 start-0 translate-middle-y z-3"
          onClick={() => swiperRef.current?.slidePrev()}
          style={isMobile ? { marginLeft: "-0px" } : { marginLeft: "-28px" }}
        >
          <i className="bi bi-arrow-left text-purple3"></i>
        </button>
        <button
          className="btn btn-purple3 rounded-circle btn-icon position-absolute mt-7 end-0 translate-middle-y z-3"
          onClick={() => swiperRef.current?.slideNext()}
          style={isMobile ? { marginRight: "-0px" } : { marginRight: "-28px" }}
        >
          <i className="bi bi-arrow-right text-purple3"></i>
        </button>

        {/* Loader or Swiper */}
        {loading ? (
          <div className="d-flex gap-4">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="p-4"
                style={{ flex: "1 0 30%", borderRadius: "20px" }}
              >
                <Skeleton height={150} borderRadius={20} />
                <Skeleton height={25} width={`60%`} className="mt-3" />
                <Skeleton height={18} width={`80%`} />
              </div>
            ))}
          </div>
        ) : (
          <Swiper
            modules={[Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            pagination={{ clickable: true }}
            grabCursor={true}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            style={{ paddingBottom: "40px" }}
          >
            {cbtList.map((cbt, index) => (
              <SwiperSlide key={index}>
                <div
                  onClick={() =>
                    navigate("./create", {
                      state: {
                        trigger: null,
                        required: null,
                        message: null,
                        cbtId: cbt.token_id, // assuming cbt.token_id exists
                      },
                    })
                  }
                  className="card bg-tiles p-4 text-center position-relative overflow-hidden shadow-none cursor-pointer"
                  style={{
                    borderRadius: "20px",
                    color: "white",
                  }}
                >
                  <i
                    className="bi bi-journal-text position-absolute"
                    style={{
                      fontSize: "5rem",
                      top: "-20px",
                      right: "-20px",
                      transform: "rotate(-25deg)",
                      opacity: 0.15,
                      pointerEvents: "none",
                    }}
                  ></i>
                  <div className="fs-4 fw-semibold mb-1">{cbt.title}</div>
                  <div className="text-light small fs-5">
                    {cbt.cbt_subject} • {cbt.timer} mins
                  </div>
                  <div className="text-light small fs-5">{cbt.task_type}</div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="col ms-2">
                    <div className="fs-4 text-dark">
                      {cbt?.instruction ? <>Ai-generated</> : <> Manual Input</>}
                    </div>
                  </div>

                  <div className="col-end text-end">
                    <div className="btn btn-white rounded-pill" onDoubleClick={() => handleDeleteCbt(cbt.token_id)}>
                      <i className="bi bi-trash fs-3 text-danger"></i>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default CBTCarousel;
